import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ListModule } from '../listbutton/list.module';
import { ButtonModule } from '../button/button.module';
import { DropDownButtonComponent } from './dropdownbutton.component';
/**
 * @hidden
 *
 * The exported package module.
 *
 * The package exports:
 * - `DropDownButtonComponent`&mdash;The DropDownButtonComponent component class.
 */
var DropDownButtonModule = (function () {
    function DropDownButtonModule() {
    }
    return DropDownButtonModule;
}());
export { DropDownButtonModule };
DropDownButtonModule.decorators = [
    { type: NgModule, args: [{
                declarations: [DropDownButtonComponent],
                exports: [DropDownButtonComponent, ListModule],
                imports: [CommonModule, PopupModule, ListModule, ButtonModule]
            },] },
];
/** @nocollapse */
DropDownButtonModule.ctorParameters = function () { return []; };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-buttons/dist/es/dropdownbutton/dropdownbutton.module.js
// module id = ../../../../@progress/kendo-angular-buttons/dist/es/dropdownbutton/dropdownbutton.module.js
// module chunks = 3